class slideShowPrimary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const slider = this.querySelector('.slider');
    if (!slider) return;

    // Add Swiper classes
    slider.classList.add('swiper');
    const slides = slider.querySelectorAll('.slider__slide');
    slides.forEach(slide => slide.classList.add('swiper-slide'));
    slider.classList.add('swiper-wrapper');

    // Wrap slides in a Swiper container if needed
    if (!slider.parentElement.classList.contains('swiper-container')) {
      const swiperContainer = document.createElement('div');
      swiperContainer.classList.add('swiper-container');
      slider.parentNode.insertBefore(swiperContainer, slider);
      swiperContainer.appendChild(slider);
    }

    // Get autoplay and speed from data attributes, default autoplay to true
    const autoplayAttr = this.getAttribute('data-autoplay');
    const speedAttr = this.getAttribute('data-speed');
    const autoplayEnabled = autoplayAttr === null || autoplayAttr === "true";
    const delay = (parseInt(speedAttr, 10) || 5) * 1000;

    // Swiper navigation and pagination elements
    const nextBtn = this.querySelector('.slider-button--next');
    const prevBtn = this.querySelector('.slider-button--prev');
    const paginationWrapper = this.querySelector('.slideshow__control-wrapper');

    // Initialize Swiper
    new Swiper(slider.parentElement, {
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: paginationWrapper,
        clickable: true,
        bulletClass: 'slider-counter__link slider-counter__link--dots link',
        bulletActiveClass: 'slider-counter__link--active',
        renderBullet: function (index, className) {
          // aria-label and aria-controls for accessibility
          const total = slides.length;
          const ariaLabel = `Load slide ${index + 1} of ${total}`;
          const ariaControls = slider.id || '';
          return `<button class="${className}" aria-label="${ariaLabel}" aria-controls="${ariaControls}"><span class="dot"></span></button>`;
        }
      },
      autoplay: autoplayEnabled ? {
        delay: delay,
        disableOnInteraction: false,
      } : false,
    });
  }
}

customElements.define('slideshow-primary', slideShowPrimary);